<template>
  <div class="user-content" :class="{ 'user-content-statistics': statisticsIsOpen }">
      <div class="header-nav-news adm">
        <div class="page-title" v-if="displayPageTitle">{{pageTitle}}</div>
<!--         <b-link
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="flat-primary"
      size="sm"
      class="btn-sm btn-nav-link"
      title="Adicionar"
    >
      <feather-icon icon="PlusIcon" class="mr-50" />
      <span class="align-middle">Adicionar</span>
    </b-link> -->
     <!-- container: popover renderizado ao lado do botão; anexado ao body ele abria fora da tela com zoom 110%/125% -->
     <b-popover
          ref="popover-change-zoom"
          target="popover-change-zoom"
          container="popover-change-zoom-container"
          triggers="hover"
          :delay="{ show: 50, hide: 300 }"
          placement="bottom"
        >
          <change-zoom></change-zoom>
        </b-popover>
        <span id="popover-change-zoom-container" class="popover-zoom-container">
          <b-button
            id="popover-change-zoom"
            ref="popover-change-zoom"
            class="btn-sm btn-nav-link"
            size="sm"
            variant="flat-primary"
          >
            <feather-icon icon="SettingsIcon" />
          </b-button>
        </span>
        <user-dropdown class="user-content-dropdown" v-if="canDisplayUserModal" @open-user-modal="openUserModal"></user-dropdown>
      </div>
      <router-view />

      <!-- User Modal -->
      <b-modal
        v-if="canDisplayUserModal"
        modal-class="modal-primary custom-user-modal"
        ref="user-modal"
        size="lg"
        centered
        no-close-on-backdrop
      >
        <div class="d-block">
          <account-setting></account-setting>
        </div>
      </b-modal>
      <!-- /User Modal -->
  </div>
</template>

<script>

import { BModal, BButton, BPopover } from 'bootstrap-vue'
import UserDropdown from '@/layouts/components/UserDropdown.vue';
import AccountSetting from '@/views/pages/account-setting/AccountSetting.vue';
import AppConstants from '@/appConstants';
import ChangeZoom from "@/views/components/ChangeZoom.vue";
export default {
  components: { 
    ChangeZoom,
    BPopover,
    // eslint-disable-next-line vue/no-unused-components
    BModal,
    BButton,
    // BLink,
  UserDropdown, 
    AccountSetting 
  },
  computed: {
    statisticsIsOpen() {
      return this.$route.path == AppConstants.NAVIGATION_PAGE_STATISTICS;
    },
    canDisplayUserModal() {
      return this.$route.path != AppConstants.NAVIGATION_PAGE_MANAGE_NEWS;
    },
    pageTitle() {
      return this.$store.state.admin.pageTitle;
    },
    displayPageTitle() {
      return this.$route.path.includes('admin');
    }
  },
  methods: {
    openUserModal() {
      this.$refs["user-modal"].show();
    }
  }
}
</script>

<style>

</style>